import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as QuicksightEmbedding from 'amazon-quicksight-embedding-sdk';
import { HhsgSharedQuicksightService } from '../../../services/quicksight.service';

@Component({
  selector: 'hhsg-quicksight',
  templateUrl: './quicksight.component.html',
  styleUrls: ['./quicksight.component.scss']
})
export class HhsgSharedQuicksightComponent implements OnDestroy, OnInit {
    @Input() dashboardId: string;
    @Input() footerPaddingEnabled: string = "false";
    @Input() printEnabled: string ="false";
    @Input() dashboardParameters : object = {};

    public readonly dashboardContainer = "dashboardContainer"; 
    public dashboard: any;

    private subscriptions: Subscription = new Subscription();

    constructor(private _quicksightService: HhsgSharedQuicksightService) { 

    }

    public ngOnDestroy(): void {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }

    public ngOnInit(): void {
        this.subscriptions.add(
            this._quicksightService.getDashboardUrl(this.dashboardId,this.dashboardParameters).subscribe(url => {
                this.embedDashboard(url);
            }));
    }

    private embedDashboard(embeddedUrl: any): void {
        const containerDiv = document.getElementById(this.dashboardContainer);
        const options = {
            container: containerDiv,
            height: "850px",
            scrolling: "yes",
            url: embeddedUrl,
            width: "100%",
            parametersChangeCallback: this.parametersChangeCallbackFunction,
            selectedSheetChangeCallback: this.selectedSheetChangeCallbackFunction,
            loadCallback: this.loadCallbackFunction,         
        };
        if(this.dashboardParameters){
            const dashboardParametersUpdated =  {};
            Object.keys(this.dashboardParameters).forEach((key) => {
                dashboardParametersUpdated[key] = this.dashboardParameters[key]['data'];
            });
            options['parameters'] = dashboardParametersUpdated;
        }
        if(this.printEnabled){
            options['printEnabled'] = this.printEnabled;
        }
        if(this.footerPaddingEnabled){
            options['footerPaddingEnabled'] = this.footerPaddingEnabled;
        }
        this.dashboard = QuicksightEmbedding.embedDashboard(options);
    }
    parametersChangeCallbackFunction(){
        sessionStorage.setItem("iframeDataChange",'true');
    }
    selectedSheetChangeCallbackFunction(){
        sessionStorage.setItem("iframeDataChange",'true');
    }
    loadCallbackFunction(){
        sessionStorage.setItem("iframeDataChange",'true');
    }
}
